var i = Object.defineProperty;
var n = (t, e, s) => e in t ? i(t, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : t[e] = s;
var r = (t, e, s) => (n(t, typeof e != "symbol" ? e + "" : e, s), s);
import h from "jwt-decode";
class f {
  constructor(e) {
    r(this, "ssoProfiles", {});
    r(this, "expiresAt");
    r(this, "name");
    r(this, "email");
    this.ssoProfiles = (e == null ? void 0 : e.profiles) || {}, this.expiresAt = e.exp, this.name = (e == null ? void 0 : e.name) || (e == null ? void 0 : e.email) || (e == null ? void 0 : e.sub), this.email = (e == null ? void 0 : e.email) || (e == null ? void 0 : e.name) || (e == null ? void 0 : e.sub);
  }
  expired() {
    return (/* @__PURE__ */ new Date()).getTime() > this.expiresAt * 1e3;
  }
  hasSsoRole(e) {
    return !!this.ssoProfiles[e];
  }
  hasSsoProfile(e, s) {
    return this.getSsoRoleIdentities(e).includes(s);
  }
  getSsoRoles() {
    return Object.keys(this.ssoProfiles);
  }
  getSsoRoleIdentities(e) {
    return this.ssoProfiles[e] || [];
  }
  hasAnyOfTheseSsoRoles(...e) {
    if (!e || e.length === 0)
      throw Error("No roles informed");
    return this.getSsoRoles().filter((s) => e.includes(s)).length > 0;
  }
  hasAllOfTheseSsoRoles(...e) {
    if (!e || e.length === 0)
      throw Error("No roles informed");
    return this.getSsoRoles().filter((s) => e.includes(s)).length === e.length;
  }
}
function m(t) {
  if (t)
    try {
      const e = h(t);
      return new f(e);
    } catch (e) {
      console.error(e);
    }
}
export {
  f as J,
  m as j
};
